import classNames from 'classnames';
import * as React from 'react';
import type { ReactNode } from 'react';
import { Button } from '../Button/Button';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { Collapse } from '~/Partials/Collapse/Collapse';
import styles from './Filters.module.css';
import { FiltersWrapper } from './FiltersWrapper';

interface FiltersTranslations {
    hideFilters: string;
    showFilters: string;
    filters: string;
}

interface CollapseFiltersProps {
    translations: FiltersTranslations;
    filters: ReactNode | ((toggleFilters: () => void) => ReactNode);
    shouldDisplayFilters?: () => boolean;
    buttonOpenedClassname?: string;
    contentExpandedClassname?: string;
}

export const CollapseFilters: React.FunctionComponent<React.PropsWithChildren<CollapseFiltersProps>> = props => {
    const { translations, filters, shouldDisplayFilters, buttonOpenedClassname, contentExpandedClassname } = props;
    const [isOpened, setIsOpened] = React.useState(false);
    const [isExpanded, setIsExpanded] = React.useState(false);
    const toggleCollapse = () => setIsOpened(!isOpened);

    return (
        <>
            {(shouldDisplayFilters === undefined || shouldDisplayFilters()) && (
                <FiltersWrapper translations={translations}>
                    <>
                        <Button
                            onClick={toggleCollapse}
                            className={classNames(styles.Button, isOpened && buttonOpenedClassname)}
                        >
                            {isOpened ? (
                                <>
                                    <SvgIcon iconName="minus" /> {translations.hideFilters}
                                </>
                            ) : (
                                <>
                                    <SvgIcon iconName="plus" /> {translations.showFilters}
                                </>
                            )}
                        </Button>
                        <Collapse
                            isOpen={isOpened}
                            className={classNames(styles.Content, isExpanded && contentExpandedClassname)}
                            onRest={() => setIsExpanded(!isExpanded)}
                        >
                            {typeof filters === 'function' ? filters(toggleCollapse) : filters}
                        </Collapse>
                    </>
                </FiltersWrapper>
            )}
        </>
    );
};
